<template>
    <dialog-notify
        ref="max-instance-reached"
        :title="title"
    >
        <div slot="content">
            <div v-if="$store.state.api.modelsFlagLoaded.organizationData">
                <p v-html="text"></p>
            </div>
        </div>
    </dialog-notify>
</template>

<script>

import DialogNotify from '@/components/Partials/dialog-notify.vue';
import { mapGetters } from 'vuex';
export default {

    components: {
        DialogNotify,
    },

    props: {
    },

    data (){
        return {
        };
    },

    computed: {
        ...mapGetters([
            'allowedInstances',
        ]),

        title (){
            if(window.config.free_version) {
                return this.$t('partials.dialog_max_running_instance.title_free_version');
            }
            return this.allowedInstances === 0 ?
                this.$t('partials.dialog_max_running_instance.title_none') :
                this.$t('partials.dialog_max_running_instance.title_max');
        },

        text (){
            if(window.config.free_version) {
                return this.$t('partials.dialog_max_running_instance.text_max',
                {allowedApp: window.config.max_applications_allowed, concreteSite : window.config.concrete_site});
            }
            return this.allowedInstances === 0 ?
            this.$t('partials.dialog_max_running_instance.text_none') :
            this.$t('partials.dialog_max_running_instance.text_max_instances' ,
                {instanceCount: this.allowedInstances }
            );
        },
    },

    mounted (){

    },

    methods: {
        open(){
            this.$refs['max-instance-reached'].open();
        }
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Partials/dialog-max-running-instance-reached.vue